"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var shopify_service_1 = require("./shopify.service");
var common_helper_1 = require("../helpers/common.helper");
var CartService = /** @class */ (function (_super) {
    __extends(CartService, _super);
    function CartService() {
        var _this = _super.call(this) || this;
        _this.cart = {};
        return _this;
    }
    CartService.prototype.set = function (cart) {
        this.cart = cart;
    };
    CartService.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, _super.prototype.get.call(this, '/cart.js')];
                    case 1:
                        _a.cart = _b.sent();
                        return [2 /*return*/, this.cart];
                }
            });
        });
    };
    CartService.prototype.post = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.post.call(this, '/cart', data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CartService.prototype.updateQuantity = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.post.call(this, '/cart/update.js', data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CartService.prototype.change = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.post.call(this, '/cart/change.js', data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CartService.prototype.remove = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.get.call(this, "/cart/change?id=" + id + "&amp;quantity=0")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CartService.prototype.update = function (addVariantIds, removeVariantIds, threshold, customCoupon) {
        if (removeVariantIds === void 0) { removeVariantIds = []; }
        if (threshold === void 0) { threshold = null; }
        if (customCoupon === void 0) { customCoupon = null; }
        return __awaiter(this, void 0, void 0, function () {
            var data, _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.mapUpdateCartData()];
                    case 1:
                        data = _b.sent();
                        if (!removeVariantIds.length) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.removeItemsFromCart(data, removeVariantIds)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        if (!addVariantIds.length) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.addItemsToCart(data, addVariantIds, threshold, customCoupon)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        _a = this;
                        return [4 /*yield*/, this.post(data)];
                    case 6:
                        _a.cart = _b.sent();
                        if (Object.keys(data.updates).length === 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.updateCartItemDetails(data)];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        err_1 = _b.sent();
                        console.log(err_1);
                        return [2 /*return*/, alert('Error. Can not update cart.')];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    CartService.prototype.updateCartItemDetails = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var line, _i, _a, cartItem, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        line = 1;
                        _i = 0, _a = this.cart.items;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        cartItem = _a[_i];
                        if (!data.updates[cartItem.id]) {
                            return [3 /*break*/, 3];
                        }
                        if (!data.updates[cartItem.id].properties) {
                            data.updates[cartItem.id].properties = {};
                        }
                        delete data.updates[cartItem.id].id;
                        data.updates[cartItem.id].line = line;
                        _b = this;
                        return [4 /*yield*/, this.change(data.updates[cartItem.id])];
                    case 2:
                        _b.cart = _c.sent();
                        line++;
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CartService.prototype.addItemsToCart = function (updateCartData, addVariantIds, threshold, customCoupon) {
        if (threshold === void 0) { threshold = null; }
        if (customCoupon === void 0) { customCoupon = null; }
        return __awaiter(this, void 0, void 0, function () {
            var _i, addVariantIds_1, variantId;
            return __generator(this, function (_a) {
                for (_i = 0, addVariantIds_1 = addVariantIds; _i < addVariantIds_1.length; _i++) {
                    variantId = addVariantIds_1[_i];
                    if (updateCartData.updates[variantId]) {
                        updateCartData.updates[variantId].quantity++;
                    }
                    else {
                        updateCartData.updates[variantId] = {
                            id: variantId,
                            quantity: 1,
                            properties: {}
                        };
                        if (threshold) {
                            updateCartData.updates[variantId].properties._threshold = {
                                id: threshold._id,
                                value: threshold.value
                            };
                        }
                        if (customCoupon) {
                            updateCartData.updates[variantId].properties._custom_coupon = customCoupon;
                        }
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    CartService.prototype.removeItemsFromCart = function (updateCartData, removeVariantIds) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, removeVariantIds_1, id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _i = 0, removeVariantIds_1 = removeVariantIds;
                        _a.label = 1;
                    case 1:
                        if (!(_i < removeVariantIds_1.length)) return [3 /*break*/, 4];
                        id = removeVariantIds_1[_i];
                        return [4 /*yield*/, this.remove(id)];
                    case 2:
                        _a.sent();
                        delete updateCartData.updates[id];
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CartService.prototype.mapUpdateCartData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, cartItems, _i, cartItems_1, cartItem;
            return __generator(this, function (_a) {
                data = {
                    updates: {}
                };
                try {
                    if (!this.cart) {
                        return [2 /*return*/, data];
                    }
                    cartItems = this.cart.items;
                    if (!cartItems) {
                        return [2 /*return*/, data];
                    }
                    for (_i = 0, cartItems_1 = cartItems; _i < cartItems_1.length; _i++) {
                        cartItem = cartItems_1[_i];
                        data.updates[cartItem.id] = {
                            id: cartItem.id,
                            quantity: cartItem.quantity
                        };
                    }
                    data.updates = common_helper_1.reverseObj(data.updates);
                    return [2 /*return*/, data];
                }
                catch (err) {
                    console.log(err);
                    return [2 /*return*/, data];
                }
                return [2 /*return*/];
            });
        });
    };
    CartService.prototype.mapUpdateCartItemsQuantityData = function (data) {
        var quantityUpdateData = { updates: {} };
        for (var itemId in data.updates) {
            if (data.updates[itemId].quantity > 1) {
                quantityUpdateData.updates[itemId] = data.updates[itemId].quantity;
            }
        }
        return quantityUpdateData;
    };
    return CartService;
}(shopify_service_1["default"]));
exports["default"] = CartService;
